import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import Route from './common/AuthRoute';

import Profile from './common/User/Profile';

import Dashboard from './dashboard/Dashboard';

// items
import Items from './items/Items';
import ItemCard from './items/ItemCard';
import EditItem from './items/EditItem';
import NewItem from './items/NewItem';

// purchaseunits
import PurchaseUnits from './purchaseunits/PurchaseUnits';
import AddPurchaseUnit from './purchaseunits/AddPurchaseUnit';
import EditPurchaseUnit from './purchaseunits/EditPurchaseUnit';

// vendors
import Vendors from './vendors/VendorList';
import VendorCard from './vendors/VendorCard';
import EditVendor from './vendors/EditVendor';
import NewVendor from './vendors/NewVendor';

// purchasesuggestions
import NewPurchaseSuggestion from './purchasesuggestions/NewPurchaseSuggestion';
import PurchaseSuggestionsOverview from './purchasesuggestions/PurchaseSuggestionsOverview';
import PurchaseSuggestionReadOnly from './purchasesuggestions/PurchaseSuggestionReadOnly';
import ConfirmPurchaseSuggestionAccounting from './purchasesuggestions/ConfirmPurchaseSuggestionAccounting';
import ConfirmPurchaseSuggestionMayor from './purchasesuggestions/ConfirmPurchaseSuggestionMayor';

// purchaseorders
import PurchaseOrderOverview from './purchaseorders/PurchaseOrderOverview';
import OrderedPurchaseOrderOverview from './purchaseorders/OrderedPurchaseOrderOverview';
import PurchaseOrder from './purchaseorders/PurchaseOrder';
import OrderedPurchaseOrder from './purchaseorders/OrderedPurchaseOrder';
import PurchaseOrderHistory from './purchaseorders/PurchaseOrderHistory';
import PurchaseOrderHistoryEntry from './purchaseorders/PurchaseOrderHistoryEntry';

// shipments
import NewShipment from './shipments/NewShipment';
import PreparedShipment from './shipments/PreparedShipment';
import NewShipmentWithoutOrder from './shipments/NewShipmentWithoutOrder';

// withdrawalreceipts
import WithdrawalReceipt from './withdrawalreceipts/WithdrawalReceipt';

// storagelocations
import StorageLocationListContainer from './storagelocations/StorageLocationListContainer';

// stocktaking
import StocktakingList from './stocktaking/StocktakingList';
import StocktakingView from './stocktaking/StocktakingView';

// reports
import Timepark from './reports/Timepark';
import BdeBuchungen from './reports/BdeBuchungen';

const Routes = () => {
  return (
    <div id="content">
      <Switch>
        <Route exact path="/" component={Dashboard} />

        <Route exact path="/profile" component={Profile} claim="items:read" />

        <Route exact path="/items" component={Items} claim="items:read" />
        <Route exact path="/items/new" component={NewItem} claim="items:write" />

        <Route exact path="/items/:itemId" component={ItemCard} claim="items:read" />
        <Route exact path="/items/edit/:itemId" component={EditItem} claim="items:write" />

        <Route exact path="/items/:itemId/vendors" component={PurchaseUnits} claim="items:write" />
        <Route exact path="/items/:itemId/vendors/:vendorId/units/new" component={AddPurchaseUnit} claim="items:write" />
        <Route exact path="/items/:itemId/vendors/:vendorId/units/:unitId" component={EditPurchaseUnit} claim="items:write" />

        <Route exact path="/vendors" component={Vendors} claim="vendors:read" />
        <Route exact path="/vendors/new" component={NewVendor} claim="vendors:write" />
        <Route exact path="/vendors/:vendorId" component={VendorCard} claim="vendors:read" />
        <Route exact path="/vendors/edit/:vendorId" component={EditVendor} claim="vendors:write" />

        <Route exact path="/purchasesuggestions/overview" component={PurchaseSuggestionsOverview} claim="purchasesuggestions:read" />
        <Route exact path="/purchasesuggestions/new" component={NewPurchaseSuggestion} claim="purchasesuggestions:new" />
        <Route exact path="/purchasesuggestions/accounting/:suggestionId" component={ConfirmPurchaseSuggestionAccounting} claim="purchasesuggestions:accounting" />
        <Route exact path="/purchasesuggestions/mayor/:suggestionId" component={ConfirmPurchaseSuggestionMayor} claim="purchasesuggestions:mayor,purchasesuggestions:stadtamtsdirektor,purchasesuggestions:bauhofleiter" />
        <Route exact path="/purchasesuggestions/:suggestionId" component={PurchaseSuggestionReadOnly} claim="purchasesuggestions:read" />

        <Route exact path="/purchaseorders/overview" component={PurchaseOrderOverview} claim="purchaseorders:read" />
        <Route exact path="/purchaseorders/ordered/overview" component={OrderedPurchaseOrderOverview} claim="purchaseorders:read" />
        <Route exact path="/purchaseorders/:id" component={PurchaseOrder} claim="purchaseorders:read" />
        <Route exact path="/purchaseorders/ordered/:id" component={OrderedPurchaseOrder} claim="purchaseorders:read" />
        <Route exact path="/purchaseordershistory/" component={PurchaseOrderHistory} claim="purchaseorders:read" />
        <Route exact path="/purchaseordershistory/:id" component={PurchaseOrderHistoryEntry} claim="purchaseorders:read" />

        <Route exact path="/shipments/new/:purchaseOrderId" component={NewShipment} claim="purchaseorders:read" />
        <Route exact path="/shipments/prepared/:purchaseOrderId" component={PreparedShipment} claim="purchaseorders:read" />
        <Route exact path="/shipments/new" component={NewShipmentWithoutOrder} claim="purchaseorders:newshipment" />

        <Route exact path="/withdrawals/new" component={WithdrawalReceipt} claim="purchaseorders:write" />

        <Route exact path="/storagelocations" component={StorageLocationListContainer} claim="storagelocations:read" />

        <Route exact path="/stocktaking" component={StocktakingList} claim="stocktaking:read" />
        <Route exact path="/stocktaking/:id" component={StocktakingView} claim="stocktaking:read" />

        <Route exact path="/reports/timepark" component={Timepark} claim="timepark:read" />
        <Route exact path="/reports/bde_buchungen" component={BdeBuchungen} claim="timepark:read" />

        <Redirect from="*" to="/" />
      </Switch>
    </div>
  );
};


export default Routes;



// WEBPACK FOOTER //
// ./src/components/Routes.js